import Texter from "../texter.es6";
import ProgressButton from "../progressButton";
import Modaller from "./../modaller";
import Former  from "./../former.es6";

require('jquery-form')($);

export default class NewCollectionAction {
    constructor(opts) {
        this.opts = opts || {};
        this.l18n = Texter.create(opts.l18n);
        this.result = null;
    }

    execute() {
        Modaller.showRemote(`${Flashcards.root}/new-collection-modal`, (modal) => {
            const form = modal.content.find('form');

            modal.setTitle(this.l18n.get('collectionForm.modal.title'));
            modal.centerFooterButtons();
            modal.addFooterButton(this.l18n.get("button.save"), "btn btn-primary btn-ok", function () {
                form.submit();
            });
            modal.addFooterButton(this.l18n.get('button.cancel'), "btn btn-secondary btn-cancel", function () {
                modal.close();
            });
            modal.setCloseHandler(() => {
                ($.isFunction(this.opts.onComplete) ? this.opts.onComplete : $.noop)(this);
            });

            const btnOk = new ProgressButton(modal.content.find('.btn-ok'));

            form.ajaxForm({
                beforeSubmit: function (arr, $form, options) {
                    btnOk.progress = true;
                    new Former($form).clearErrors();
                },
                error: function (jqXHR, textStatus, error, $form) {
                    const json = jqXHR.responseJSON;
                    if (json && json.message === 'bad request') {
                        new Former($form).bindErrors(json.bindingErrors);
                    }
                    btnOk.progress = false;
                },
                success: (data, textStatus, jqXHR, $form) => {
                    if (data.success) {
                        this.result = data;
                        modal.close();
                        btnOk.progress = false;
                    }
                }
            });
        });
    }
}